'use client';

import React from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html data-component-id="src/app/global-error.tsx:13:4" data-component-path="src/app/global-error.tsx" data-component-line="13" data-component-end-line="87" data-component-file="global-error.tsx" data-component-name="html" data-component-content="%7B%22elementName%22%3A%22html%22%7D" lang="en">
      <body data-component-id="src/app/global-error.tsx:14:6" data-component-path="src/app/global-error.tsx" data-component-line="14" data-component-end-line="86" data-component-file="global-error.tsx" data-component-name="body" data-component-content="%7B%22elementName%22%3A%22body%22%7D"
        style={{ margin: 0, fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif' }}
      >
        <div data-component-id="src/app/global-error.tsx:17:8" data-component-path="src/app/global-error.tsx" data-component-line="17" data-component-end-line="85" data-component-file="global-error.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            background: 'linear-gradient(135deg, #070c16 0%, #0a1020 60%, #0d1525 100%)',
            color: '#e2e8f0',
          }}
        >
          <div data-component-id="src/app/global-error.tsx:28:10" data-component-path="src/app/global-error.tsx" data-component-line="28" data-component-end-line="84" data-component-file="global-error.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" style={{ maxWidth: 440, textAlign: 'center' }}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img data-component-id="src/app/global-error.tsx:30:12" data-component-path="src/app/global-error.tsx" data-component-line="30" data-component-end-line="36" data-component-file="global-error.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%2Fassets%2Fimages%2FCFVA-logo-tagline-1775363438977.png%22%2C%22alt%22%3A%22CFVA%22%7D"
              // global-error renders when the Next.js root has crashed, so
              // next/Image is unsafe here — fall back to a plain <img>.
              src="/assets/images/CFVA-logo-tagline-1775363438977.png"
              alt="CFVA"
              style={{ height: 44, margin: '0 auto 24px', opacity: 0.9 }}
            />
            <h1 data-component-id="src/app/global-error.tsx:37:12" data-component-path="src/app/global-error.tsx" data-component-line="37" data-component-end-line="39" data-component-file="global-error.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22textContent%22%3A%22Something%20went%20wrong%22%7D" style={{ fontSize: 22, fontWeight: 600, margin: '0 0 8px' }}>
              Something went wrong
            </h1>
            <p data-component-id="src/app/global-error.tsx:40:12" data-component-path="src/app/global-error.tsx" data-component-line="40" data-component-end-line="48" data-component-file="global-error.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22textContent%22%3A%22The%20app%20hit%20an%20unexpected%20error.%20You%20can%20try%20again%20or%20reload%20the%20page.%22%7D" style={{ color: '#94a3b8', fontSize: 14, margin: '0 0 20px', lineHeight: 1.5 }}>
              The app hit an unexpected error. You can try again or reload the page.
              {error.digest ? (
                <>
                  <br data-component-id="src/app/global-error.tsx:44:18" data-component-path="src/app/global-error.tsx" data-component-line="44" data-component-end-line="44" data-component-file="global-error.tsx" data-component-name="br" data-component-content="%7B%22elementName%22%3A%22br%22%7D" />
                  <span data-component-id="src/app/global-error.tsx:45:18" data-component-path="src/app/global-error.tsx" data-component-line="45" data-component-end-line="45" data-component-file="global-error.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Ref%3A%22%7D" style={{ fontSize: 11, opacity: 0.7 }}>Ref: {error.digest}</span>
                </>
              ) : null}
            </p>
            <div data-component-id="src/app/global-error.tsx:49:12" data-component-path="src/app/global-error.tsx" data-component-line="49" data-component-end-line="83" data-component-file="global-error.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button data-component-id="src/app/global-error.tsx:50:14" data-component-path="src/app/global-error.tsx" data-component-line="50" data-component-end-line="65" data-component-file="global-error.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22Try%20again%22%7D"
                onClick={reset}
                style={{
                  background: 'linear-gradient(to right, #4f46e5, #7c3aed)',
                  color: '#fff',
                  border: 'none',
                  padding: '10px 22px',
                  borderRadius: 10,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: '0 10px 24px rgba(79,70,229,0.25)',
                }}
              >
                Try again
              </button>
              <button data-component-id="src/app/global-error.tsx:66:14" data-component-path="src/app/global-error.tsx" data-component-line="66" data-component-end-line="82" data-component-file="global-error.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22textContent%22%3A%22Go%20home%22%7D"
                onClick={() => {
                  window.location.href = '/';
                }}
                style={{
                  background: 'rgba(255,255,255,0.08)',
                  color: '#cbd5e1',
                  border: 'none',
                  padding: '10px 22px',
                  borderRadius: 10,
                  fontSize: 14,
                  fontWeight: 500,
                  cursor: 'pointer',
                }}
              >
                Go home
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
